import { makeStyles } from '@mui/styles';
import BackIcon from '@mui/icons-material/ArrowBack';

import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  ({ palette, spacing }) => ({
    root: {
      textDecoration: 'none',
      '&:hover': {
        color: palette.brand.main,
      },
    },
    icon: {
      marginRight: spacing(2.5),
      verticalAlign: 'top',
    },
  }),
  { classNamePrefix: 'BackLink' }
);

export default function BackLink({ children, component = 'a', ...otherProps }) {
  const classes = useStyles();

  return (
    <Typography
      className={classes.root}
      variant="subheading"
      component={component}
      display="inline"
      {...otherProps}
    >
      <BackIcon className={classes.icon} />
      {children}
    </Typography>
  );
}
